import { bindRequestLogic } from './utils'
import NotificationTemplateTypes from '../actionTypes/notificationTemplate'
import { notificationTemplateAPI, platformPageTechAPI } from '../api'

const getNotificationTemplates = bindRequestLogic({
  clientFunc: notificationTemplateAPI.getNotificationTemplates,
  type: NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATES_REQUEST,
  successType: NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATES_SUCCESS,
  failType: NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATES_FAILED,
  isQueryParam: true
})

const getNotificationTemplate = bindRequestLogic({
  clientFunc: notificationTemplateAPI.getNotificationTemplateDetail,
  type: NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATE_DETAIL_REQUEST,
  successType:
    NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATE_DETAIL_SUCCESS,
  failType: NotificationTemplateTypes.GET_NOTIFICATION_TEMPLATE_DETAIL_FAILED
})

const addNotificationTemplate = bindRequestLogic({
  clientFunc: notificationTemplateAPI.addNotificationTemplate,
  type: NotificationTemplateTypes.ADD_NOTIFICATION_TEMPLATE_REQUEST,
  successType: NotificationTemplateTypes.ADD_NOTIFICATION_TEMPLATE_SUCCESS,
  failType: NotificationTemplateTypes.ADD_NOTIFICATION_TEMPLATE_FAILED
})

const updateNotificationTemplate = bindRequestLogic({
  clientFunc: notificationTemplateAPI.updateNotificationTemplate,
  type: NotificationTemplateTypes.UPDATE_NOTIFICATION_TEMPLATE_REQUEST,
  successType: NotificationTemplateTypes.UPDATE_NOTIFICATION_TEMPLATE_SUCCESS,
  failType: NotificationTemplateTypes.UPDATE_NOTIFICATION_TEMPLATE_FAILED
})

const deleteNotificationTemplate = bindRequestLogic({
  clientFunc: notificationTemplateAPI.deleteNotificationTemplate,
  type: NotificationTemplateTypes.DELETE_NOTIFICATION_TEMPLATE_REQUEST,
  successType: NotificationTemplateTypes.DELETE_NOTIFICATION_TEMPLATE_SUCCESS,
  failType: NotificationTemplateTypes.DELETE_NOTIFICATION_TEMPLATE_FAILED
})

export const getPageTechInNotificationTemplate = bindRequestLogic({
  clientFunc: platformPageTechAPI.getPlatformPageTechs,
  type: NotificationTemplateTypes.GET_PLATFORM_PAGE_TECH_IN_NOTIFICATION_TEMPLATE_REQUEST,
  successType:
    NotificationTemplateTypes.GET_PLATFORM_PAGE_TECH_IN_NOTIFICATION_TEMPLATE_SUCCESS,
  failType:
    NotificationTemplateTypes.GET_PLATFORM_PAGE_TECH_IN_NOTIFICATION_TEMPLATE_FAILED,
  isQueryParam: true
})

export const getSystemNotificationTemplates = bindRequestLogic({
  clientFunc: notificationTemplateAPI.getSystemNotificationTemplates,
  type: NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATES_REQUEST,
  successType:
    NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATES_SUCCESS,
  failType: NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATES_FAILED,
  isQueryParam: true
})

export const getSystemNotificationTemplateById = bindRequestLogic({
  clientFunc: notificationTemplateAPI.getSystemNotificationTemplateById,
  type: NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATE_BY_ID_REQUEST,
  successType:
    NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATE_BY_ID_SUCCESS,
  failType:
    NotificationTemplateTypes.GET_SYSTEM_NOTIFICATION_TEMPLATE_BY_ID_FAILED
})

export default [
  getNotificationTemplates,
  getNotificationTemplate,
  addNotificationTemplate,
  updateNotificationTemplate,
  deleteNotificationTemplate,
  getPageTechInNotificationTemplate,
  getSystemNotificationTemplates,
  getSystemNotificationTemplateById
]
